import React from 'react';
import { graphql } from 'gatsby';
import AboutTemplate from 'templates/about';
import { useTranslation } from 'react-i18next';

const AboutPage = props => {
  const [t] = useTranslation();
  return (
    <AboutTemplate
      {...props}
      seoTitle={t('page--about.seoTitle')}
      seoDescription={t('page--about.seoDescription')}
    />
  )
};
export default AboutPage;

export const query = graphql`
  query AboutPage {
    strapiPages(slug: { eq: "/foretaget/om-oss" }) {
      id
      title
      subtitle
      headerImage {
        childImageSharp {
          fluid(maxHeight: 1024, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      jsonData {
        title
      }
      content
      seoTitle
      seoDescription
    }
    # allStrapiEmployee {
    #   edges {
    #     node {
    #       name
    #       position
    #       image
    #     }
    #   }
    # }
  }
`;
